import SensorSettingEditor from './sensor-setting-editor';

export default SensorSettingEditor;